/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RixsusMerchants } from './rixsus-merchants';

/**
 *
 * @export
 * @interface Rixsus
 */
export class Rixsus {
    /**
     *
     * @type {string}
     * @memberof Rixsus
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Rixsus
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Rixsus
     */
    type: string;
    /**
     *
     * @type {RixsusMerchants}
     * @memberof Rixsus
     */
    merchants: RixsusMerchants;
    /**
     *
     * @type {boolean}
     * @memberof Rixsus
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Rixsus
     */
    autoApprove: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Rixsus
     */
    amountFromDB: boolean;
}
